/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logindesc1Inputs */

const zh_auth_logindesc1 = /** @type {(inputs: Auth_Logindesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的邮箱登录账户`)
};

const en_auth_logindesc1 = /** @type {(inputs: Auth_Logindesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email below to login to your account`)
};

const es_auth_logindesc1 = /** @type {(inputs: Auth_Logindesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu correo electrónico para iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Enter your email below to login to your account" |
*
* @param {Auth_Logindesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_logindesc1 = /** @type {((inputs?: Auth_Logindesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logindesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_logindesc1(inputs)
	if (locale === "en") return en_auth_logindesc1(inputs)
	return es_auth_logindesc1(inputs)
});
export { auth_logindesc1 as "auth_loginDesc" }